export default __webpack_public_path__ + "static/media/night-lord.260f01ac.png";